import {
    WORKFLOW_LIST_REQUESTED,
    WORKFLOW_LIST_RECEIVED,
    WORKFLOW_LIST_ERROR
} from '../actions/workflowList.js';
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
 *
 * @param {RequestResult} state
 * @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
 * @return {RequestResult}
 */
export const workflowList = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

    switch (action.type) {
        case WORKFLOW_LIST_REQUESTED:
            return new RequestResult(RequestState.getInstanceLoading(), state.data);
        case WORKFLOW_LIST_RECEIVED:
            return new RequestResult(RequestState.getInstanceDone(), action.workflowList, action.receivedAt);
        case WORKFLOW_LIST_ERROR:
            return new RequestResult(
                RequestState.getInstanceError(
                    action.errorResponseStatusCode,
                    action.errorResponseMessage ? action.errorResponseMessage : null
                ),
                state.getData()
            );
        default:
            return state
    }
};
